import orderBlockStyles from '~/styles/bookingFlow/order-block.module.css';

type Props = {
  children: React.ReactNode;
};

export default function OrderBlockWrapper({ children }: Props) {
  return (
    <div className={orderBlockStyles.orderBlockWrapper}>
      {children}
    </div>
  );
}
